import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SortableContainer } from 'react-sortable-hoc';
import { getWeddingPartyMemberRole } from './WeddingPartyMemberRoles';
import {
  getWeddingPartyMembers,
  editWeddingPartyMember,
} from '../../../../actions/website/entities/WeddingPartyMembersActions';
import { moveEntity, resetEntities, addEntity } from '../../../../actions/website/EntityActions';
import { showModal } from '../../../../actions/ModalActions';
import { togglePage } from '../../../../actions/website/PageActions';
import EditPageForm from './EditPageCommon/EditPageFormContainer';
import EditPageHeader from './EditPageCommon/EditPageHeader';
import EditPageAddEntity from './EditPageCommon/EditPageAddEntity';
import { EntityName, EntityType } from './EditPageCommon/EditPageSortableList';

const MemberDetails = entity => {
  const member = entity || {};
  const { name, role, custom_role: customRole } = member;
  const memberRole = role === 'CUSTOM' ? customRole : getWeddingPartyMemberRole(role);

  return (
    <>
      <EntityType type={memberRole} />
      <EntityName name={name} />
    </>
  );
};

class WeddingPartyMembers extends Component {
  componentDidMount() {
    const { getWeddingParty } = this.props;
    getWeddingParty();
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  render() {
    const {
      weddingPartyMembers,
      orderedIds,
      editMember,
      deleteMember,
      openModal,
      page,
      themeKey,
      onPageToggle,
    } = this.props;
    const pageType = page && page.type;
    return (
      <div>
        {themeKey && (
          <EditPageHeader
            page={page}
            onAdd={openModal}
            themeKey={themeKey}
            onPageToggle={onPageToggle}
          />
        )}
        <>
          <EditPageForm page={page} />
          <EditPageAddEntity
            entityName="Person"
            pageType={pageType}
            orderedIds={orderedIds}
            entities={weddingPartyMembers}
            onAdd={openModal}
            onEdit={editMember}
            onDelete={deleteMember}
            entityDetail={MemberDetails}
          />
        </>
      </div>
    );
  }
}

WeddingPartyMembers.propTypes = {
  weddingPartyMembers: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getWeddingParty: PropTypes.func.isRequired,
  editMember: PropTypes.func.isRequired,
  deleteMember: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
};

const mapStateToProps = state => ({
  weddingPartyMembers: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.WEDDING_PARTY],
  themeKey: state.wedding.theme.key,
});

const mapDispatchToProps = dispatch => ({
  editMember: member => {
    console.log(member);
    dispatch(editWeddingPartyMember(member));
    dispatch(showModal('WEDDING_PARTY', { isUpdate: true }, { size: 'md' }));
  },
  deleteMember: entity => {
    dispatch(showModal('DELETE_ENTITY', { entity }));
  },
  getWeddingParty: () => {
    dispatch(getWeddingPartyMembers());
  },
  onSortEnd: ({ oldIndex, newIndex }) => {
    dispatch(moveEntity(oldIndex, newIndex));
  },
  openModal: () => {
    dispatch(addEntity());
    dispatch(showModal('WEDDING_PARTY', {}, { size: 'md' }));
  },
  unloadEntities: () => {
    dispatch(resetEntities());
  },
  onPageToggle: pageId => dispatch(togglePage(pageId)),
});

const SortableWeddingPartyMembers = SortableContainer(WeddingPartyMembers);

const WeddingPartyMembersContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SortableWeddingPartyMembers);

export default WeddingPartyMembersContainer;
